import { browser } from '$app/environment';

export function toggleFullScreen(element: HTMLElement = document.documentElement) {
    if (!browser) return Promise.reject();
    return !document.fullscreenElement ? element.requestFullscreen() : document.exitFullscreen();
}
